import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
    <g fill="none" stroke="null">
      <circle cx="25" cy="25" r="25" fill="#000" opacity=".1" />
      <g fill="#FFF">
        <path d="M14.42 18.664V35.65c0 .92.371 1.8 1.031 2.45a3.545 3.545 0 0 0 2.487 1.014h14.139c.933 0 1.827-.365 2.487-1.014.66-.65 1.03-1.53 1.03-2.45V18.664c0-.426-.35-.77-.781-.77a.776.776 0 0 0-.782.77V35.65c0 .51-.206 1-.572 1.361a1.97 1.97 0 0 1-1.382.564H17.938a1.97 1.97 0 0 1-1.382-.564 1.91 1.91 0 0 1-.572-1.36V18.663c0-.205-.082-.4-.229-.545a.788.788 0 0 0-.553-.225.776.776 0 0 0-.781.77zM12.784 16.302a.788.788 0 0 0 .553.225h23.337a.776.776 0 0 0 .781-.77c0-.425-.35-.77-.781-.77h-5.35V11.99c0-.51-.205-1-.572-1.361a1.97 1.97 0 0 0-1.382-.564h-8.73a1.97 1.97 0 0 0-1.382.564 1.91 1.91 0 0 0-.572 1.36v2.999h-5.35a.775.775 0 0 0-.78.77c0 .204.082.4.228.544zm7.465-4.312c0-.213.175-.385.391-.385h8.73c.104 0 .204.04.277.112.073.073.115.17.115.273v2.998H20.25V11.99z" />
      </g>
      <circle cx="25" cy="25" r="24" stroke="#FFF" />
    </g>
  </svg>
);

const IconTrash: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconTrash;
